export const getSx = () => {
  return {
    sidebarContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "stretch",
      backgroundColor: "#F1F1F1",
      height: "100%",
      padding: { xs: "15px 0", md: "30px 0"},
      zIndex: 9,
      boxSizing: "border-box",
    },
    sidebarItems: {
      display: "flex",
      gap: { xs: "0", md: "1rem" },
      alignItems: "center",
      position: "relative",
      padding: "0 45px",
    },
    smallLogo: {
      aspectRatio: "1.46",
      objectFit: "contain",
      objectPosition: "center",
      width: "48px",
      height: "56px",
      overflow: "hidden",
      maxWidth: "100%",
    },
    profileName: {
      fontSize: "20px",
      fontWeight: "600",
      lineHeight: 1.2,
      textTransform: "capitalize",
      display: { xs: "none", md: "block" },
    },
    email: {
      fontSize: "15px",
      fontWeight: "500",
      opacity: 0.8,
      lineHeight: 1.1,
      display: { xs: "none", md: "block" },
    },
    arrowLeftCircle: {
      cursor: "pointer",
      position: "absolute",
      bottom: "-85px",
      right: "-42px",
    },
    itemList: {
      width: "100%",
      padding: "2.5vh 0",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
    },
    sidebarItemContainer: {
      display: "flex",
      position: "relative",
      alignItems: "center",
      cursor: "pointer",
      borderRadius: "32px",
      margin: { xs: "5px 10px", md: "4% 15px" },
      fontWeight: 500,
    },
    sidebarItem: {
      width: "6px",
      height: "24px",
      borderRadius: "0 4px 4px 0",
      position: "absolute",
      left: 0,
      top: 0,
      bottom: 0,
      margin: "auto",
    },
    imageContainer: {
      width: "24px",
      height: "24px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    sidebarLabel: {
      fontSize: "16px",
      fontWeight: 400,
      my: "auto",
      paddingLeft: "15px",
      filter: "revert(-1)",
    },
    logoutContainer: {
      display: "flex",
      position: "fixed",
      bottom: "2%",
      alignItems: "center",
      cursor: "pointer",
      padding: "18px",
      fontWeight: 500,
      margin: { xs: "5px 10px", md: "8px 15px" },
    },
    logoutIcon: {
      backgroundColor: "white",
      width: "6px",
      height: "24px",
      borderRadius: "0 4px 4px 0",
      position: "absolute",
      left: 0,
      top: 0,
      bottom: 0,
      margin: "auto",
      opacity: 0,
    },
    logoutText: {
      color: "#343434",
      fontSize: "16px",
      fontWeight: 500,
      my: "auto",
      paddingLeft: "15px",
      display: { xs: "none", md: "block" },
    },
  };
};
